<label class="form-field-label error-label">Dieses Feld ist erforderlich</label>

<style>
    .error-label {
        color: red;
        font-size: 12px;
        margin-top: -4px;
        font-weight: bold;
    }
</style>
